/// <amd-module name="Wit/DeliveryPlans/Board/BoardContracts" />

import { Marker } from "Wit/Clients/Work/Contracts/Work";

export interface BoardMarker extends Marker {
    /**
     * Allow default markers to use theme variables
     */
    className?: string;
}
